import React from 'react'

import { CheckListStyled, CheckListItemStyled } from './styles'
import { CheckListProps } from './types'

const CheckList: React.FC<CheckListProps> = ({ list }) => {
  return (
    <CheckListStyled>
      {list && list.map(({ key, title, isAwarded }) => <CheckListItemStyled {...{ key, isAwarded }}>{title}</CheckListItemStyled>)}
    </CheckListStyled>
  )
}

export default CheckList
